var MembershipStatus;
!function (e) {
  e.Active = "active", e.Archived = "archived", e.Cancelled = "cancelled", e.Failed = "failed", e.Paused = "paused";
}(MembershipStatus || (MembershipStatus = {}));
var ActiveMembershipStatuses = [MembershipStatus.Active, MembershipStatus.Failed, MembershipStatus.Paused];
export { MembershipStatus, ActiveMembershipStatuses };